import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import * as path from "./constants/Paths"
//import BookingStarter from './components/bookingStarter'
//const BookingStarter = React.lazy(() => import(/* webpackPrefetch: true */ './components/bookingStarter'));
import BookingHero from "./components/bookingHero"
import ReactHtmlParser from "react-html-parser"

export default class ParkingTransportBookingHero {
  constructor() {
    this.config = {}
    this.heroData = {}
    this.init()
    return this
  }
  init() {
    const parkingTransportBookingHeroContainer = document.querySelector("[data-parking-transport-booking-hero]")
    if (parkingTransportBookingHeroContainer) {
      console.log(parkingTransportBookingHeroContainer.dataset)
      this.heroData =
        (parkingTransportBookingHeroContainer.dataset.parkingTransportBookingHero &&
          JSON.parse(parkingTransportBookingHeroContainer.dataset.parkingTransportBookingHero)) ||
        {}
      this.config =
        (parkingTransportBookingHeroContainer.dataset.parkingBookingstarter &&
          JSON.parse(parkingTransportBookingHeroContainer.dataset.parkingBookingstarter)) ||
        {}

      let subtitle = this.heroData.subTitle
      let title = this.heroData.title
      let buttonText = this.heroData.buttonText
      let tooltipHeadline = this.heroData.tooltipHeadline
      let tooltipText = this.heroData.tooltipText
      let tooltipPreviewText = this.heroData.tooltipPreviewText
      let tooltipReadMoreEllipsis = this.heroData.tooltipReadMoreEllipsis
      let refundGuaranteeText = this.heroData.refundGuaranteeText
      let refundGuaranteeImage = this.heroData.refundGuaranteeImage
      const locale = this.config["locale"] || "da"
      const textKeys = this.config["textKeys"]?.bookingStarter || {}

      ReactDOM.render(
        <Suspense fallback={ReactHtmlParser(parkingTransportBookingHeroContainer.innerHTML)}>
          <BookingHero
            imageUrl={(this.heroData && this.heroData.imageUrl) || "/static/photos/Kran_1600x600.png"}
            videoUrl={(this.heroData && this.heroData.videoUrl) || "/static/video/Kran_1600x600.mp4"}
            headline={subtitle || 'Parkering fra kun <span class="t--highlight">395,-</span> pr. uge'}
            label={title || "Parkering & Transport"}
            button={buttonText || "Book nu"}
            locale={locale}
            textKeys={textKeys}
            performParkingSearch={this.performParkingSearch}
            showDefaultDates={false}
            tooltipHeadline={tooltipHeadline}
            tooltipText={tooltipText}
            tooltipPreview={tooltipPreviewText}
            tooltipReadMore={tooltipReadMoreEllipsis || "... læs mere"}
            refundGuaranteeText={refundGuaranteeText}
            refundGuaranteeImage={refundGuaranteeImage || ""}
            leadTimeInHours={textKeys.leadTimeInHours || 1.0}
          />
        </Suspense>,
        parkingTransportBookingHeroContainer,
      )
    }
  }

  performParkingSearch = (arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode) => {
    const locale = this.config["locale"] || "da"
    const url = `${path.SEARCH(locale)}?ad=${arrivalDate}&at=${arrivalTime}&dd=${departureDate}&dt=${departureTime}${
      voucher ? "voucher=" + voucher : ""
    }${affiliateCode ? "&affiliate=" + affiliateCode : ""}`
    //  console.log (`booking pressed: ${url}`)
    window.location.assign(url)
  }
}
